"use strict";
window.theme = window.theme || {}
theme.ComponentsAgeGateWithCookiesBanner = function() {
    function ComponentsAgeGateWithCookiesBanner() {
        this.container = {
        };

        this.load();               

    }
    ComponentsAgeGateWithCookiesBanner.prototype.load = function() {
        var _ = this;
        if(_.getcookie() === 'passed') {
            _.asyncawaitcookiesconsent(1);
        } else {
            _.asyncawaitcookiesconsent(0);
            let age_gate_input = document.getElementById("shopify-section-age-gate");
            age_gate_input.querySelector('.StepYear.AgStep');
                    if(age_gate_input) {
                        age_gate_input.addEventListener('input', event => {
                        setTimeout( () => {
                            if(_.getcookie() === 'passed') {
                            _.asyncawaitcookiesconsent(1);
                            }
                    }, 1000);
                    })          
            }
        }
    }
    ComponentsAgeGateWithCookiesBanner.prototype.getcookie = function() {
        let name = 'agegate=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return 'on';
    }
    ComponentsAgeGateWithCookiesBanner.prototype.asyncawaitcookiesconsent = function(state) {
        let keeprotateuntil = 0;
        let keeplookingcookiesconsent = setInterval(() => {
            let cookiesbannerfound = document.getElementById('onetrust-consent-sdk');
            if(cookiesbannerfound) {
                cookiesbannerfound.style.setProperty('opacity', state);                
                clearInterval(keeplookingcookiesconsent);
            } else {
                keeprotateuntil++;
            }
            if(keeprotateuntil > 88) {
                clearInterval(keeplookingcookiesconsent);        
            }
        },100);
        keeplookingcookiesconsent;
    }

    theme.ComponentsAgeGateWithCookiesBanner = new ComponentsAgeGateWithCookiesBanner;
}

theme.ComponentsAgeGateWithCookiesBanner();
